

    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorChatActivo } from '../../controlador';
    import { Envio } from '@/__env/lib/Ventas/Envios';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorChatActivo;
        @Prop()
        public Pedido: Pedido;
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Cliente() { return this.Pedido.Cliente; }
        public get Envio() { return this.Pedido.Envio; }
    }


